<template>
    <div class="legend">
        <div
            v-for="item in displayItems"
            :key="item.key"
            class="item"
        >
            <div
                class="indicator"
                :style="{ 'background-color': item.markerColor }"
            />
            <div class="label">{{ item.shortText }}</div>
            <div class="label-xs">{{ item.xsText || item.shortText }}</div>
        </div>
    </div>
</template>

<script>
import { programTypes } from "./consts";

export default {
    name: "TimeLineLegendMobile",

    computed: {
        displayItems() {
            return Object.values(programTypes);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/rem";

.legend {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: center;
    background-color: #ffffff;

    @include on-xs {
        padding: 8px 16px;
    }
}

.item {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    margin: 0 16px 0 0;
    white-space: nowrap;

    @include on-xs {
        margin: 0 8px 0 0;
    }

    &:last-of-type {
        margin: 0;

        @include on-xs {
            margin: 0;
        }
    }
}

.indicator {
    width: 8px;
    height: 8px;
    margin-right: 6px;
    border-radius: 50%;
}

.label, .label-xs {
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    color: #98A0A9;
}

.label {
    display: block;

    @include on-xs {
        display: none;
    }
}
.label-xs {
    display: none;

    @include on-xs {
        display: block;
    }
}
</style>